import { useEffect, useRef, useState } from "react";
import { useTabStore } from "@/pages/desktop-coupon/store/tab-store";
import { CouponStatus, CouponType } from "@/pages/desktop-coupon/constant";
import { ICouponListInfo } from "../types";

export function useCurrentCouponList() {
  const [currentCouponList, setCurrentCouponInfoList] = useState<
    ICouponListInfo[]
  >([]);
  const tabRef = useRef<HTMLDivElement>(null);
  const { currentTab, couponInfo, activeKey } = useTabStore();
  const initScrollNum = 40;

  const handleFilterCoupon = (
    currentTab: CouponType,
    selectValue: CouponStatus,
    isShowAll?: boolean
  ) => {
    const filterDataSource =
      couponInfo?.filter((item) => item.type === currentTab) || [];
    if (!filterDataSource.length) return;
    const subData = [
      Object.assign(
        { ...filterDataSource[0] },
        {
          data: filterDataSource[0].data.filter(
            (item: any) => !!item.isExpired === !!selectValue
          ),
        }
      ),
    ];
    const filterData =
      selectValue !== CouponStatus.All ? subData : filterDataSource;
    const sourceData = isShowAll ? filterData : handleLoadingCoupon(filterData);
    if (!sourceData) return;
    let result = JSON.parse(JSON.stringify(sourceData));
    if (selectValue !== CouponStatus.All) {
      result[0].data = sourceData[0].data.filter(
        (item: any) => !!item.isExpired === !!selectValue
      );
    }
    setCurrentCouponInfoList(result);
  };

  const handleLoadingCoupon = (source?: ICouponListInfo[]) => {
    if (!source) return;
    let currentCouponInfo = [...source];
    if (currentCouponInfo.length && currentCouponInfo[0].sum > initScrollNum) {
      currentCouponInfo = [];
      let total = 0;
      source?.forEach((item) => {
        if (total > initScrollNum) return;
        if (item.sum + total <= initScrollNum) {
          total += item.sum;
          currentCouponInfo?.push(item);
        } else {
          const result = { data: item.data.slice(0, 50 - total - 1) };
          currentCouponInfo?.push({ ...item, ...result });
          total = initScrollNum + 1;
        }
      });
    }
    return currentCouponInfo;
  };

  useEffect(() => {
    if (tabRef && tabRef.current) {
      tabRef.current.scrollTop = 0;
    }
    const result = handleLoadingCoupon(
      couponInfo?.filter((item) => item.type === currentTab) || []
    );

    if (!result) return;
    setCurrentCouponInfoList(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab, couponInfo, activeKey]);

  return {
    currentCouponList,
    setCurrentCouponInfoList,
    tabRef,
    handleFilterCoupon,
  };
}
